import { CommonProp } from 'constants/'
import { NoteResponse } from 'types'

const makeReadResponseValue = (note: NoteResponse) => (propName: string) =>
  note?.[CommonProp.RESPONSES]?.[propName]?.[CommonProp.RESPONSE_VALUE]

export { makeReadResponseValue }
